import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import getAppUrls from '../../constants/appUrls';
import { jsx as _jsx } from "react/jsx-runtime";
export const ManageSeatsButton = () => {
  const {
    paidUsersManagementUrl
  } = getAppUrls();
  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "manage-seats-button",
    use: "primary",
    href: paidUsersManagementUrl,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "calling-orchestration-shared-library.unlock-calling.paid-seat-blocking.manage-seats-button-text"
    })
  });
};